import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getDigestionItemsForTransferHolidayStatus,
  downloadTransferHolidayCsv,
  getTransferHolidayStatusDetail,
} from 'api/holidayManagement';
import moment from 'moment';
import TransferHolidayStatusDomain from 'domain/master/holidayManagement/transferHolidayStatus';
import useToastNotification from 'hooks/useToastNotification';
import { HolidayManagementContext } from './../HolidayManagementForm'

export interface DetailItems {
  staffCode: string,
  staffName: string,
  orgCode: any,
  orgName: any,
  transferDayNumb: any,
  attendTransfer: [],
  targetDateFrom: Date,
  targetDateTo: Date,
}

export const useHolidayManagementRestForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [transferHolidayStatusList, setTransferHolidayStatusList] = useState<Array<TransferHolidayStatusDomain>>([]);
  const [noManager, setNoManager] = useState(false);
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const [searchDate, setSearchDate] = useState<Date>(new Date());
  const [modalOpen, setModalOpen] = useState(false);
  const [detailItems, setDetailItems] = useState<DetailItems>({
    staffCode: '',
    staffName: '',
    orgCode: '',
    orgName: '',
    transferDayNumb: '',
    attendTransfer: [],
    targetDateFrom: new Date(),
    targetDateTo: new Date(),
  });
  const { errorNotification } = useToastNotification();

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    const response = await getDigestionItemsForTransferHolidayStatus(
      orgCode !== 'all' ? orgCode : '',
      String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
    );
    contextObject.setIsLoading(false);
    setTransferHolidayStatusList(response.map((result) => new TransferHolidayStatusDomain(result)));
  }, [orgCode, searchDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgCode, searchDate]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  //
  const callGetTransferHolidayStatusDetail = useCallback(async (staffCode: string) => {
    try {
      await getTransferHolidayStatusDetail(
        staffCode,
        String(moment(moment(searchDate).toDate()).format('YYYY/MM/DD')),
      ).then((response: any) => {
        setDetailItems(response);
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        listErr.map((element: any) => errorNotification(element.defaultMessage));
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
        throw error;
      }
    }
  }, [errorNotification, searchDate]);

  return {
    transferHolidayStatusList,
    callGetTransferHolidayStatusDetail,
    toggleNoManager,
    orgCode,
    setOrgCode,
    searchDate,
    setSearchDate,
    modalOpen,
    setModalOpen,
    closeModal,
    detailItems,
    setDetailItems,
  };
};

export const useDownloadHolidayManagementRest = (
  orgCode: string,
  targetDate: Date,
) => {
  const [blocking, setBlocking] = useState(false);
  const downloadHolidayManagementRest = useCallback((isDownloadAll?: boolean) => {
    setBlocking(true);
    downloadTransferHolidayCsv(
      isDownloadAll ? '' : orgCode,
      String(moment(moment(targetDate).toDate()).format('YYYY/MM/DD')),
    ).then(() => {
      setBlocking(false);
    });
  }, [orgCode, targetDate]);

  return {
    blocking,
    downloadHolidayManagementRest
  };
};

export default {
  useHolidayManagementRestForm,
};
